import type { IConfig } from '@/composables/request'

// 获取书架书籍列表
export function asyncGetBookShelfList(params: { page: number; per_page: number }) {
  return request({
    url: '/tapon/bookcase',
    method: 'get',
    params,
    noMessage: true,
  } as IConfig)
}

// 书架添加书籍
export function asyncAddBookShelf(data: { novel_id: number }) {
  return request({
    url: '/tapon/bookcase/add',
    method: 'post',
    data,
    noMessage: true,
  } as IConfig)
}

// 书架移除书籍
export function asyncRemoveBookShelf(data: { novel_id: number | number[] }) {
  return request({
    url: '/tapon/bookcase/del',
    method: 'post',
    data,
    noMessage: true,
  } as IConfig)
}

// 获取历史记录列表
export function asyncGetHistoryList(params: { page: number; per_page: number }) {
  return request({
    url: '/tapon/history',
    method: 'get',
    params,
    noMessage: true,
  } as IConfig)
}

// 添加历史记录
export function asyncAddHistory(data: { novel_id?: number }) {
  return request({
    url: '/tapon/history/add',
    method: 'post',
    data,
    noMessage: true,
    noLoad: true,
  } as IConfig)
}

// 清除浏览记录
export function asyncClearHistory(data: { novel_ids?: number[] }) {
  return request({
    url: '/tapon/history/del',
    method: 'post',
    data,
  })
}
